"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.brief.topic': 'Argomento / brief',
    'socialMediaPlan.brief.topicPlaceholder': 'es. Nuova collezione estiva...',
    'socialMediaPlan.brief.goal': 'Obiettivo',
    'socialMediaPlan.brief.tone': 'Tono',
    'socialMediaPlan.brief.contentType': 'Tipo contenuto',
    'socialMediaPlan.brief.contentType.image': 'Immagine',
    'socialMediaPlan.brief.contentType.carousel': 'Carosello',
    'socialMediaPlan.brief.contentType.video': 'Video',
    'socialMediaPlan.brief.contentType.story': 'Storia',
    'socialMediaPlan.brief.contentType.thread': 'Thread',
    'socialMediaPlan.brief.audience': 'Pubblico target',
    'socialMediaPlan.brief.cta': 'CTA',
    'socialMediaPlan.brief.ctaPlaceholder': 'es. Acquista ora, Scopri di più, Iscriviti...',
    'socialMediaPlan.brief.platforms': 'Piattaforme target',
    'socialMediaPlan.brief.platformsHint': 'L\'AI adatterà lunghezza, stile e hashtag separatamente per ogni piattaforma selezionata.',
};
